export const wrapper = {
    maxWidth: '100px',
    width: '100%',
    aspectRatio: '3 / 1',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const canvas = {
    width: '180%',
    height: 'auto',
    objectFit: 'contain',
    flexShrink: 0,
};
